<template lang="pug">
  div(v-if="conversa.status !== 'ENCERRADA'")
    validation-observer(ref='validation' tag='div')
      validation-provider(rules="required", v-slot="{ errors }")
        div
          el-radio-group.paddin-5(:class="verificaCampoComErro(errors)", v-model="possuiPosseMansaEPacifica")
            el-radio(:label="true")
              span Sim
            el-radio(:label="false")
              span Não
          span.help.erro(v-if="errors.length") Campo obrigatório
    div.upload(v-if="possuiPosseMansaEPacifica")
      app-documentos(
        :maxSize='20',
        :valid-extensions="extensoes",
        :documentos="documentos"
        :tiposDocumentos="tiposDocumentos",
        :tiposDocumentosObrigatorios="[]",
        :observer="this.$refs.validation",
        :isDocumentoImagex="true"
        titulo="Documentos do Interessado",
        :pecasTecnicas="true"
        aba="Interessado",
        :mensagemOutros="mensagemOutros"
      )
    .buttons
      el-button(
        type="default",
        @click="$router.push({ name: 'caixa-entrada' })"
      ) Cancelar

      el-button(
        type="success",
        @click="enviar"
      ) Enviar
  div(v-else)
    div.card-content-texto-info
      span.card-content Dados já enviados ao ITERPA.
</template>

<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos'

export default {

  components: {
    AppDocumentos
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    conversa: {
      type: Object,
      required: true
    },
    tipoCadastro: {
      type: String,
      required: true
    },
    mensagemOutros: {
      type: String,
      required: false
    }
  },

  data () {
    return {
      tiposDocumentos: [],
      extensoes: ['pdf', 'jpeg', 'png', 'jpg'],
      documentos: [],
      possuiPosseMansaEPacifica: null
    }
  },

  async created () {
    this.tiposDocumentos = await this.findTiposDocumentoPosseMansaEPacifica({
      protocolo: this.protocolo
    })
    this.$store.commit('conversas/SET_TIPO_ANEXOS_PENDENTES_CONVERSA', this.tiposDocumentos)
  },

  methods: {
    ...mapActions({
      findTiposDocumentoPosseMansaEPacifica:
        'tipoDocumento/findTiposDocumentoPosseMansaEPacifica',
      enviaDocumentosVistoriaRemota: 'processo/enviaDocumentosVistoriaRemota'
    }),
    enviar () {
      if (this.possuiPosseMansaEPacifica && !this.documentos.length) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.MINIMO_UM_DOCUMENTO
        )
        return
      }
      this.$refs.validation.validate().then(success => {
        if (success) {
          this.confirmBox(this.mensagemModal(),
            this.$messages.TITULO_WARNING,
            async () => {
              await this.enviaDocumentosVistoriaRemota({
                conversaId: this.conversa.id,
                documentos: this.documentos.map(b => ({
                  nome: b.fileName,
                  key: b.fileKey,
                  tipo: b.tipoDocumento
                })),
                possuiPosseMansaEPacifica: this.possuiPosseMansaEPacifica
              })
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.MENSAGEM_SUCESSO_ENVICO_DOCUMENTOS_VISTORIA_REMOTA
              )
              this.$router.back()
            },
            () => {})
        }
      })
    },
    verificaCampoComErro (errors) {
      return {
        'is-invalid': errors.length
      }
    },
    mensagemModal () {
      if (this.possuiPosseMansaEPacifica) {
        return this.$messages[`TEXTO_CONFIRMA_ENVIO_DOCUMENTOS_VISTORIA_REMOTA_${this.tipoCadastro}`]
      } else {
        return this.$messages[`TEXTO_NAO_ENVIO_DOCUMENTOS_VISTORIA_REMOTA_${this.tipoCadastro}`]
      }
    }
  }
}

</script>

<style scoped lang="scss">
@import '@/assets/styles/element-variables.scss';

.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.card-content-texto-info {
  margin-top: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
}

.card-content {
  font-size: 0.9em;
  color: #666;
}

.paddin-5 {
  padding: 5px;
}

.is-invalid {
  border: 1px solid red;
  border-radius: 5px;
}

</style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppDocumentosPosseMansaEPacifica.vue